// components/ErrorBoundary.js
import React, { useEffect, useState } from "react";
import { ErrorBoundary } from "react-error-boundary";
import ModalWrapper from "./ModalWrapper";

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  const [isShow, setIsShow] = useState(false);
  useEffect(() => {
    setIsShow(true); // Ensure the modal is shown on error
  }, [error]);
  return (
    <ModalWrapper
      isShow={isShow}
      setIsShow={setIsShow}
      okMsg={"Try again"}
      okFun={resetErrorBoundary}
    >
      <div className="flex items-center justify-center">
        <div className="bg-white p-2 rounded-lg text-center max-w-sm w-full">
          <h3 className="text-lg font-semibold text-red-600">
            Something Went Wrong:
          </h3>
          {/* <p className="mt-2 text-sm text-gray-800">{"jjj"+error}</p> */}
          <div dangerouslySetInnerHTML={{ __html: error }} />
        </div>
      </div>
    </ModalWrapper>
  );
};

const ReactErrorBoundary = ({ children }) => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}
      onReset={() => {
        // Reset the state of your application here if needed
      }}
    >
      {children}
    </ErrorBoundary>
  );
};

export default ReactErrorBoundary;
